import React from 'react';
import { useReferencedComponent } from '@hooks/useReferencedComponent';
import { Results } from '@components/SectionBlocks/Testshowcase/Results/Results';
import { FormBlock } from '../Form/FormBlock';
import { FeaturedVehicleResultBlock } from '../FeaturedVehicleResultSerializer/FeaturedVehicleResultSerializer';

export interface ReferencedComponentProps {
  type: 'referencedComponent';
  documentId: string;
}

export interface ReferencedComponentSerializerProps {
  value: ReferencedComponentProps;
}

export const ReferencedComponentBlock = ({ value: { documentId } }: ReferencedComponentSerializerProps) => {
  const data = useReferencedComponent(documentId);

  if (data?.type === 'dynamicForm') {
    return <FormBlock value={{ _key: '', _type: 'dynamicForm', dynamicForm: data }} />;
  }
  if (data?.type === 'bodyFeaturedVehicleTestResult') {
    return <FeaturedVehicleResultBlock value={data} />;
  }
  if (data?.type === 'testResultBlockGlobal') {
    return <Results block={data} />;
  }

  return null;
};
